import React from 'react';
import { Lock, Gift, Mail, Clock, ShieldCheck, CreditCard } from 'lucide-react';
const items = [{
  icon: Lock,
  text: 'Pago 100% seguro con MercadoPago'
}, {
  icon: Gift,
  text: 'OFF por tiempo limitado'
}, {
  icon: Mail,
  text: 'Acceso inmediato por mail'
}, {
  icon: Clock,
  text: 'Acceso en 5 minutos'
}, {
  icon: ShieldCheck,
  text: 'Garantía 7 días'
}, {
  icon: CreditCard,
  text: 'Tarjeta · Transferencia · Mercado Pago'
}];
export function TrustMarquee() {
  // Duplicate the list to create a seamless loop
  const loop = [...items, ...items];
  return <div className="bg-petroleum border-b border-white/5 overflow-hidden" data-id="element-726">
      <div className="relative" data-id="element-727">
        <div className="flex w-max animate-marquee gap-10 py-3 whitespace-nowrap" data-id="element-728">
          {loop.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} className="flex items-center gap-2 text-xs md:text-sm text-textsecondary font-medium px-2" data-id="element-729">
                <Icon className="w-4 h-4 text-gold flex-shrink-0" data-id="element-730" />
                <span data-id="element-731">{item.text}</span>
              </div>;
        })}
        </div>
        {/* Edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-12 bg-gradient-to-r from-petroleum to-transparent" data-id="element-732" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-12 bg-gradient-to-l from-petroleum to-transparent" data-id="element-733" />
      </div>
    </div>;
}